import { LegacyHours } from '../types/api';

/**
 * Calculate total legacy hours from all periods.
 * Returns 0 if legacyHours is null/undefined.
 */
export const calculateTotalLegacyHours = (legacyHours: LegacyHours | null | undefined): number => {
  if (!legacyHours) return 0;
  return (legacyHours.pre_2023 || 0) + (legacyHours['2023'] || 0) + (legacyHours['2024'] || 0);
};
